<template>
  <el-form-item
    class="form form-date-picker"
    :label="column.label"
    :prop="column.name"
    :class="[
      `form-${fname}-${findex}-date-picker-item-${column.name}`,
    ]">
    <template slot="label" v-if="column.hasOwnProperty('label')">
      <span
        class="inline-middle"
        :aria-label="ariaLabel">
        {{ column.label }}
      </span>
    </template>
    <el-date-picker
      v-model="form[column.name]"
      @change="onRangeChanged"
      :type="column.datePickerType || 'date'"
      :clearable="column.datePickerClearable || false"
      range-separator="|"
      :placeholder="column.datePickerPlaceholder || 'Date'"
      :start-placeholder="column.datePickerPlaceholderStart || 'Start Date'"
      :end-placeholder="column.datePickerPlaceholderEnd || 'End Date'"
      :format="column.format || FormConstants.EL_DATE_FORMAT_DISPLAY"
      :value-format="column.valueFormat || FormConstants.EL_DATE_FORMAT"
      :picker-options="column.pickerOptions"
      :disabled="disabled">
    </el-date-picker>
  </el-form-item>
</template>

<script>
import _ from 'lodash'
import FormConstants from './formconstants'
import ElementHelper from '@/util/element'

export default {
  name: 'form-date-picker',
  components: {
  },
  props: ['column', 'form', 'options', 'data', 'disabled', 'fname', 'findex'],
  data () {
    return {
    }
  },
  computed: {
    modules: function () {
      return this.$store.getters.user.modules
    },
    FormConstants: function () {
      return FormConstants
    },

    ariaLabel () {
      let label = `${this.column.labelAria || this.column.label}`
      label = label.replace(/[^a-zA-Z0-9]+/g, ' ')
      return `${label} format month slash day slash year`
    },
  },
  watch: {
  },
  created () {
  },
  async mounted () {
    await this.onInitAccessibility()
    this.refresh()
  },
  methods: {
    async refresh () {
    },

    async onInitAccessibility () {
      await this.$nextTick()
      const id = this.column && this.column.name

      // aria-fix:
      ElementHelper.byClass(`form-${this.fname}-${this.findex}-date-picker-item-${id}`, document, (elem) => {
        ElementHelper.byClass('el-input__inner', elem, (input) => {
          input.setAttribute('id', `${id}`)
        })
      })
    },

    // getData (name) {
    //   if (this.data && this.data[name] && typeof this.data[name] === 'object') {
    //     return this.data[name]
    //   }
    //   return []
    // },

    onRangeChanged () {
      let value = this.form[this.column.name]
      let colinfo = _.assign({}, this.column, { value })
      this.$emit('on-range-changed', colinfo)
    }
  }
}
</script>

<style lang="scss">
@import "../styles/base.scss";

.form-date-picker {
  .el-date-editor.el-input, .el-date-editor.el-input__inner {
    width: 100%;
  }
}

</style>
